import _ from 'underscore';

export default class AccountAssociationsRequestFactory {
  setEntityIds() {
    // do nothing since request for account association doesn't need campaign/adgroup ids
  }

  generateDestroyRequest(ids) {
    return [{
      'adExtensionAssociations': this.getBatchRequest(ids),
    }];
  }

  generateUpdateRequest(ids) {
    return [{
      'adExtensionAssociations': this.getBatchRequest(ids),
    }];
  }

  getBatchRequest(idList) {
    return _.map(idList, (id) => ({
      Type: 'Account',
      AdExtensionId: id,
    }));
  }
}
